import { Frequency, NotAppliedForSSNReason } from '../../../components/ssap/SsapTypes';

const AUTHORIZED_REPRESENTATIVE = {
    'hasUserElectronicallySigned': null,
    'signatureisProofIndicator': null,
    'phone': [
        {
            'phoneExtension': null,
            'phoneNumber': null,
            'phoneType': 'CELL'
        },
        {
            'phoneExtension': null,
            'phoneNumber': null,
            'phoneType': 'HOME'
        },
        {
            'phoneExtension': null,
            'phoneNumber': null,
            'phoneType': 'WORK'
        }
    ],
    'partOfOrganizationIndicator': null,
    'address': {
        'postalCode': null,
        'county': null,
        'primaryAddressCountyFipsCode': null,
        'streetAddress1': null,
        'streetAddress2': null,
        'state': null,
        'city': null,
        'countyCode': null,
        'addressId': 0
    },
    'name': {
        'middleName': null,
        'lastName': null,
        'firstName': null,
        'suffix': null
    },
    'emailAddress': null,
    'organizationId': null,
    'companyName': null
};

const CITIZENSHIP_DOCUMENT = {
    sevisId: null,
    foreignPassportOrDocumentNumber: null,
    alienNumber: null,
    nameOnDocument: {
        middleName: null,
        lastName: null,
        firstName: null,
        suffix: null
    },
    documentDescription: null,
    nameSameOnDocumentIndicator: null,
    visaNumber: null,
    documentExpirationDate: null,
    i94Number: null,
    foreignPassportCountryOfIssuance: null,
    cardNumber: null
};

const CITIZENSHIP_STATUS = {
    'honorablyDischargedOrActiveDutyMilitaryMemberIndicator' : null,
    'militaryFamilyMemberIndicator': null,
    'citizenshipStatusIndicator' : null,
    'eligibleImmigrationDocumentType' : [{
        'UnexpiredForeignPassportIndicator': false,
        'TemporaryI551StampIndicator': false,
        'I551Indicator': false,
        'MachineReadableVisaIndicator': false,
        'OtherDocumentTypeIndicator': false,
        'I94InPassportIndicator': false,
        'I571Indicator': false,
        'I766Indicator': false,
        'I20Indicator': false,
        'I94Indicator': false,
        'I797Indicator': false,
        'I327Indicator': false,
        'DS2019Indicator': false,
        'noneOfThese': false
    }],
    'naturalizationCertificateIndicator' : false,
    'citizenshipManualVerificationStatus' : false,
    'citizenshipAsAttestedIndicator' : false,
    'eligibleImmigrationStatusIndicator' : false,
    'citizenshipDocument' : {
        'foreignPassportOrDocumentNumber' : null,
        'sevisId' : null,
        'alienNumber' : null,
        'nameOnDocument' : {
            'middleName' : null,
            'lastName' : null,
            'firstName' : null,
            'suffix' : null
        },
        'documentDescription' : null,
        'nameSameOnDocumentIndicator' : null,
        'visaNumber' : null,
        'documentExpirationDate' : null,
        'i94Number' : null,
        'foreignPassportCountryOfIssuance' : null,
        'cardNumber' : null
    },
    'lawfulPresenceIndicator' : false,
    'naturalizationCertificateAlienNumber' : null,
    'eligibleImmigrationDocumentSelected' : null,
    'otherImmigrationDocumentType' : {
        'cubanHaitianEntrantIndicator' : false,
        'americanSamoanIndicator' : false,
        'stayOfRemovalIndicator': false,
        'orreligibilityLetterIndicator' : false,
        'orrcertificationIndicator' : false,
        'withholdingOfRemovalIndicator': false,
        'domesticViolence': false,
        'indianOfUsOrCanada': false,
        'deportationWithheldInaIndicator': false,
        'refugeeIndicator': false,
        'specialIraqiAfghaniImmigrantIndicator': false,
        'victimSevereTraffickingIndicator': false,
        'conditionalEntrantIndicator': false,
        'lawfulPermanentResidentIndicator': false,
        'paroledAtLeastOneYearIndicator': false,
        'temporaryNonimmigrantIndicator': false,
        'deferredActionChildhoodArrivalsIndicator': false,
        'amerasianNoncitizenIndicator': false,
        'asyleeIndicator': false,
        'cofaMigrantIndicator': false,
        'otherIndicator': false,
        'noneOfThese': false
    },
    'hasRefugeeStatus': null,
    'dateOfEntry': null,
    'hasI864Sponsor': null,
    'naturalizedCitizenshipIndicator' : null,
    'livedIntheUSSince1996Indicator' : null,
    'naturalizationCertificateNaturalizationNumber' : null,
    'unchangedImmigrationStatusLastFiveYears': null
};

const EMPLOYER_DETAILS = {
    'companyName': null,
    'applicantGuid': null,
    'memberName': null,
    'name': {
        'firstName': '',
        'middleName': '',
        'lastName': '',
        'suffix': ''
    },
    'phone': null,
    'email': null,
    'address': {
        'postalCode': '',
        'county': null,
        'streetAddress1': '',
        'streetAddress2': '',
        'state': '',
        'city': ''
    },
    'ein': '',
    'minimumValuePlan': null,
    'employerPremium': 0,
    'employerPremiumFrequency': 'UNSPECIFIED',
    'employerOfferAffordable': false,
    'escOfferType': null,
    'employeeEnrolled': null
};

const HOUSEHOLD_COMPOSITION = {
    'claimerIds' : [],
    'hasSpouse': null,
    'independentTaxFiler': false,
    'livesSeparatelyFromClaimerParent': null,
    'spouseOnApplication': null,
    'taxFilingStatus': 'UNSPECIFIED',
    'taxRelationship': 'UNSPECIFIED',
    'dependentOnExternalFiler': null,
    'claimedByNonCustodialParent': null,
    'claimedByOtherThanSpouseOrParent': null
};

const HRA_DETAILS = {
    personId: null,
    applicantGuid: null,
    enrolledInIchraIndicator: null,
    employerPremiumPercentage: 0,
    employerOfferAffordable: null,
    hraType: '',
    primaryInsuredMemberIdentifier: '',
    startDate: null,
    endDate: null,
    employeeSelfOnlyOfferAmount: 0,
    employeeSelfOnlyOfferFrequencyType: Frequency.MONTHLY,
    primaryInsuredMemberNotInTaxHhIndicator: null,
    employerName: '',
    employerIdentificationNumber: '',
    streetName1: null,
    streetName2: null,
    cityName: null,
    stateCode: null,
    zipCode: null,
    plus4Code: null,
    countryCode: null,
    countyName: null,
    countyFipsCode: null,
    employerPhoneNumber: null,
    name: {
        firstName: null,
        middleName: null,
        lastName: null,
        suffix: null
    },
    email: '',
    phoneNumber: ''
};

const HOUSEHOLD_CONTACT = {
    'homeAddressIndicator' : false,
    'phone' : {
        'phoneExtension' : null,
        'phoneNumber' : null,
        'phoneType' : null
    },
    'homeAddress' : {
        'postalCode' : null,
        'county' : null,
        'primaryAddressCountyFipsCode' : null,
        'streetAddress1' : null,
        'streetAddress2' : null,
        'state' : null,
        'city' : null,
        'countyCode' : null
    },
    'stateResidencyProof' : null,
    'otherPhone' : {
        'phoneExtension' : null,
        'phoneNumber' : null,
        'phoneType' : null
    },
    'contactPreferences' : {
        'emailAddress' : null,
        'preferredSpokenLanguage' : null,
        'preferredContactMethod' : null,
        'preferredWrittenLanguage' : null
    },
    'mailingAddress' : {
        'postalCode' : null,
        'county' : null,
        'primaryAddressCountyFipsCode' : null,
        'streetAddress1' : null,
        'streetAddress2' : null,
        'state' : null,
        'city' : null,
        'countyCode' : null
    },
    'mailingAddressSameAsHomeAddressIndicator' : false
};

const MEDICAID_VERIFICATION = {
    'vlpDataDirty': false,
    'nonEsiMecDataDirty': false,
    'esiMecDataDirty': false,
    'ssacDataDirty': false
};

const HOUSEHOLD_MEMBER = {
    'incomes': [],
    'expenses' : [],
    'annualTaxIncome': {
        'reportedIncome': 0,
        'projectedIncome': 0,
    },
    'medicaidVerification': MEDICAID_VERIFICATION,
    'inlineEligibility': {},
    'flagBucket': {
        'annualTaxIncomeFlags': 18,
        'taxHouseholdCompositionFlags': 604587154,
        'taxHouseholdCompositionProgressFlags': 21650
    },
    'taxHouseholdComposition': HOUSEHOLD_COMPOSITION,
    'detailedIncome' : {
        'partnershipAndSwarpIncomeIncomeProof' : null,
        'capitalGains' : {
            'annualNetCapitalGains' : null
        },
        'unemploymentBenefit' : {
            'incomeFrequency' : null,
            'stateGovernmentName' : null,
            'benefitAmount' : null,
            'unemploymentDate' : null
        },
        'annuityIncomeProof' : null,
        'scholarshipIncomeProof' : null,
        'otherIncome' : [ ],
        'receiveMAthrough1619' : null,
        'taxExemptedIncomeProof' : null,
        'wageIncomeProof' : null,
        'dividendsIncomeProof' : null,
        'farmFishingIncome' : {
            'incomeFrequency' : null,
            'netIncomeAmount' : null
        },
        'rentalRoyaltyIncomeIndicator' : false,
        'unemploymentBenefitIndicator' : false,
        'capitalGainsIndicator' : false,
        'jobIncome' : [ ],
        'alimonyReceivedIndicator' : false,
        'unemploymentCompensationIncomeProof' : null,
        'selfEmploymentTax' : {
            'incomeAmount' : null
        },
        'studentLoanInterest' : {
            'incomeAmount' : null
        },
        'selfEmploymentIncome' : {
            'monthlyNetIncome' : null,
            'typeOfWork' : null
        },
        'businessIncomeProof' : null,
        'sellingBusinessProperty' : {
            'incomeAmount' : null
        },
        'retirementOrPension' : {
            'taxableAmount' : null,
            'incomeFrequency' : null
        },
        'royaltiesIncomeProof' : null,
        'farmFishingIncomeIndictor' : false,
        'investmentIncome' : {
            'incomeAmount' : null,
            'incomeFrequency' : null
        },
        'farmIncom' : {
            'incomeAmount' : null
        },
        'deductions' : {
            'alimonyDeductionAmount' : null,
            'otherDeductionAmount' : null,
            'alimonyDeductionFrequency' : null,
            'studentLoanDeductionFrequency' : null,
            'deductionFrequency' : null,
            'studentLoanDeductionAmount' : null,
            'deductionType' : [ ],
            'otherDeductionFrequency' : null,
            'deductionAmount' : null
        },
        'rentalRoyaltyIncome' : {
            'incomeFrequency' : null,
            'netIncomeAmount' : null
        },
        'receiveMAthroughSSI' : null,
        'foreignEarnedIncomeProof' : null,
        'socialSecurityBenefit' : {
            'incomeFrequency' : null,
            'benefitAmount' : null
        },
        'foreignEarnedIncome' : {
            'incomeAmount' : null
        },
        'childNaTribe' : null,
        'sellingBusinessPropertyIncomeProof' : null,
        'alimonyReceived' : {
            'amountReceived' : null,
            'incomeFrequency' : null
        },
        'selfEmploymentTaxProof' : null,
        'partnershipsCorporationsIncome' : {
            'incomeAmount' : null
        },
        'studentLoanInterestProof' : null,
        'farmIncomeProof' : null,
        'retirementOrPensionIndicator' : false,
        'investmentIncomeIndicator' : false,
        'socialSecurityBenefitIndicator' : false,
        'rentalRealEstateIncome' : {
            'incomeAmount' : null
        },
        'otherIncomeIndicator' : false,
        'pensionIncomeProof' : null,
        'socialSecurityBenefitProof' : null,
        'jobIncomeIndicator' : false,
        'businessIncome' : {
            'incomeAmount' : null
        },
        'taxableInterestIncomeProof' : null,
        'selfEmploymentIncomeIndicator' : false,
        'rentalRealEstateIncomeProof' : null,
        'discrepancies' : {
            'hasWageOrSalaryBeenCutIndicator' : false,
            'explanationForJobIncomeDiscrepancy' : null,
            'didPersonEverWorkForEmployerIndicator' : false,
            'stopWorkingAtEmployerIndicator' : false,
            'hasHoursDecreasedWithEmployerIndicator' : false,
            'explanationForDependantDiscrepancy' : null,
            'seasonalWorkerIndicator' : false,
            'hasChangedJobsIndicator' : false
        }
    },
    'dateOfBirth' : null,
    'dateLastActiveTour' : null,
    'parentCaretakerRelatives' : {
        'relationship' : null,
        'dateOfBirth' : null,
        'mainCaretakerOfChildIndicator' : false,
        'name' : {
            'middleName' : null,
            'lastName' : null,
            'firstName' : null,
            'suffix' : null
        },
        'liveWithAdoptiveParentsIndicator' : false,
        'personId' : [ ],
        'anotherChildIndicator' : false
    },
    'specialCircumstances' : {
        'ageWhenLeftFosterCare' : null,
        'americanIndianAlaskaNativeIndicator' : false,
        'dueDateOfPregnancy': null,
        'everInFosterCareIndicator' : false,
        'fosterCareState' : null,
        'fosterChild' : null,
        'gettingHealthCareThroughStateMedicaidIndicator' : false,
        'metFosterCareConditions': false,
        'numberBabiesExpectedInPregnancy' : null,
        'pregnantIndicator' : false,
        'tribalManualVerificationIndicator' : false,
        'deceased': null,
        'deceasedDate': null
    },
    'livesWithHouseholdContactIndicator' : true,
    'socialSecurityCard' : {
        'middleNameOnSSNCard' : null,
        'deathManualVerificationIndicator' : false,
        'socialSecurityNumber' : null,
        'suffixOnSSNCard' : null,
        'individualMandateExceptionIndicator' : false,
        'ssnManualVerificationIndicator' : false,
        'deathIndicatorAsAttested' : false,
        'nameSameOnSSNCardIndicator' : null,
        'deathIndicator' : false,
        'firstNameOnSSNCard' : null,
        'socialSecurityCardHolderIndicator' : null,
        'useSelfAttestedDeathIndicator' : false,
        'lastNameOnSSNCard' : null,
        'reasonableExplanationForNoSSN' : null
    },
    'strikerIndicator' : false,
    'birthCertificateType' : null,
    'citizenshipImmigrationStatus' : {
        'honorablyDischargedOrActiveDutyMilitaryMemberIndicator' : null,
        'citizenshipStatusIndicator' : null,
        'eligibleImmigrationDocumentType' : [{
            'unexpiredForeignPassportIndicator': false,
            'temporaryI551StampIndicator': false,
            'i551Indicator': false,
            'machineReadableVisaIndicator': false,
            'otherDocumentTypeIndicator': false,
            'i94InPassportIndicator': false,
            'i571Indicator': false,
            'i766Indicator': false,
            'i20Indicator': false,
            'i94Indicator': false,
            'i797Indicator': false,
            'i327Indicator': false,
            'ds2019Indicator': false,
            'noneOfThese': false
        }],
        'naturalizationCertificateIndicator' : false,
        'citizenshipManualVerificationStatus' : false,
        'citizenshipAsAttestedIndicator' : false,
        'eligibleImmigrationStatusIndicator' : false,
        'citizenshipDocument' : {
            'foreignPassportOrDocumentNumber' : null,
            'sevisId' : null,
            'alienNumber' : null,
            'nameOnDocument' : {
                'middleName' : null,
                'lastName' : null,
                'firstName' : null,
                'suffix' : null
            },
            'documentDescription' : null,
            'nameSameOnDocumentIndicator' : null,
            'visaNumber' : null,
            'documentExpirationDate' : null,
            'i94Number' : null,
            'foreignPassportCountryOfIssuance' : null,
            'cardNumber' : null
        },
        'lawfulPresenceIndicator' : false,
        'naturalizationCertificateAlienNumber' : null,
        'eligibleImmigrationDocumentSelected' : null,
        'otherImmigrationDocumentType' : {
            'cubanHaitianEntrantIndicator' : false,
            'stayOfRemovalIndicator' : false,
            'americanSamoanIndicator' : false,
            'withholdingOfRemovalIndicator' : false,
            'orreligibilityLetterIndicator' : false,
            'orrcertificationIndicator' : false,
            'domesticViolence': false,
            'indianOfUsOrCanada': false,
            'deportationWithheldInaIndicator': false,
            'refugeeIndicator': false,
            'specialIraqiAfghaniImmigrantIndicator': false,
            'victimSevereTraffickingIndicator': false,
            'conditionalEntrantIndicator': false,
            'lawfulPermanentResidentIndicator': false,
            'paroledAtLeastOneYearIndicator': false,
            'temporaryNonimmigrantIndicator': false,
            'deferredActionChildhoodArrivalsIndicator': false,
            'amerasianNoncitizenIndicator': false,
            'asyleeIndicator': false,
            'cofaMigrantIndicator': false,
            'otherIndicator': false,
            'noneOfThese': false
        },
        'hasRefugeeStatus': null,
        'naturalizedCitizenshipIndicator' : null,
        'livedIntheUSSince1996Indicator' : null,
        'naturalizationCertificateNaturalizationNumber' : null
    },
    'medicalExpense' : null,
    'specialEnrollmentPeriod' : {
        'birthOrAdoptionEventIndicator' : false
    },
    'marriedIndicator' : false,
    'bloodRelationship' : [ ],
    'drugFellowIndicator' : false,
    'livingArrangementIndicator' : false,
    'taxFiler' : {
        'spouseHouseholdMemberId' : null,
        'claimingDependantsOnFTRIndicator' : false,
        'taxFilerDependants' : [ ],
        'liveWithSpouseIndicator' : false
    },
    'shelterAndUtilityExpense' : null,
    'tobaccoUserIndicator' : false,
    'dependentCareExpense' : null,
    'residencyVerificationIndicator' : false,
    'returnedFromTourOfActiveDuty': null,
    'taxFilerDependant' : {
        'dependantHouseholdMemeberId' : null,
        'taxFilerDependantIndicator' : false
    },
    'name' : {
        'middleName' : null,
        'lastName' : null,
        'firstName' : null,
        'suffix' : null
    },
    'ethnicityAndRace' : {
        'ethnicity' : [ ],
        'race' : [ ],
        'hispanicLatinoSpanishOriginIndicator' : null
    },
    'personId' : null,
    'householdId': 0,
    'addressId': 1,
    'gender' : null,
    'householdContactIndicator' : false,
    'americanIndianAlaskaNative' : {
        'tribeName' : null,
        'tribeFullName' : null,
        'state' : null,
        'stateFullName' : null,
        'memberOfFederallyRecognizedTribeIndicator' : null
    },
    'householdContact' : {
        'homeAddressIndicator' : false,
        'phone' : {
            'phoneExtension' : null,
            'phoneNumber' : null,
            'phoneType' : null
        },
        'homeAddress' : {
            'postalCode' : null,
            'county' : null,
            'primaryAddressCountyFipsCode' : null,
            'streetAddress1' : null,
            'streetAddress2' : null,
            'state' : null,
            'city' : null,
            'countyCode' : null
        },
        'stateResidencyProof' : null,
        'otherPhone' : {
            'phoneExtension' : null,
            'phoneNumber' : null,
            'phoneType' : null
        },
        'contactPreferences' : {
            'emailAddress' : null,
            'preferredSpokenLanguage' : null,
            'preferredContactMethod' : null,
            'preferredWrittenLanguage' : null
        },
        'mailingAddress' : {
            'postalCode' : null,
            'county' : null,
            'primaryAddressCountyFipsCode' : null,
            'streetAddress1' : null,
            'streetAddress2' : null,
            'state' : null,
            'city' : null,
            'countyCode' : null
        },
        'mailingAddressSameAsHomeAddressIndicator' : false
    },
    'applicantGuid' : null,
    'applicantPersonType': 'DEP',
    'applyingForCoverageIndicator' : null,
    'planToFileFTRJontlyIndicator' : false,
    'livesAtOtherAddressIndicator' : false,
    'employerSponsoredCoverage': [ ],
    'healthReimbursementArrangement': [ ],
    'healthCoverage' : {
        'childHaveCurrentCoverage' : null,
        'chipInsurance' : {
            'reasonInsuranceEndedOther' : null,
            'insuranceEndedDuringWaitingPeriodIndicator' : false
        },
        'haveBeenUninsuredInLast6MonthsIndicator' : false,
        'currentEmployer' : [ ],
        'formerEmployer' : [ ],
        'primaryCarePhysicianName' : null,
        'otherInsuranceIndicator' : false,
        'currentlyEnrolledInCobraIndicator' : false,
        'currentlyHasHealthInsuranceIndicator' : false,
        'employerWillOfferInsuranceIndicator' : null,
        'currentlyEnrolledInRetireePlanIndicator' : false,
        'currentOtherInsurance': {
            'otherStateOrFederalMedicaidProgramName': null,
            'otherStateOrFederalCHIPProgramName':null,
            'otherStateOrFederalPrograms': [ ],
            'currentlyEnrolledInVeteransProgram': null,
            'hasNonESI': false,
        },
        'otherInsurance': {
            'insuranceName': null,
            'policyNumber': null,
            'limitedBenefit': false
        },
        'currentlyEnrolledInVeteransProgramIndicator' : false,
        'hasPrimaryCarePhysicianIndicator' : false,
        'employerWillOfferInsuranceCoverageStartDate' : null,
        'willBeEnrolledInCobraIndicator' : false,
        'willBeEnrolledInVeteransProgramIndicator' : false,
        'medicaidInsurance' : {
            'requestHelpPayingMedicalBillsLast3MonthsIndicator' : false
        },
        'isOfferedHealthCoverageThroughJobIndicator' : false,
        'willBeEnrolledInRetireePlanIndicator' : false,
        'employerWillOfferInsuranceStartDate' : null,
        'stateHealthBenefit': null,
        'eligibleITU': null,
        'receivedITU': null,
        'unpaidBill': null,
        'coveredDependentChild': null,
        'absentParent': null
    },
    'medicareEnrollment': {
        'enrolled': null,
        'startDate': null,
        'marketplaceCoverage': 'UNSPECIFIED'
    },
    'planToFileFTRIndicator' : false,
    'otherAddress' : {
        'address' : {
            'postalCode' : null,
            'county' : null,
            'primaryAddressCountyFipsCode' : null,
            'streetAddress1' : null,
            'streetAddress2' : null,
            'state' : null,
            'city' : null,
            'countyCode' : null
        },
        'livingOutsideofStateTemporarilyAddress' : {
            'postalCode' : null,
            'county' : null,
            'primaryAddressCountyFipsCode' : null,
            'streetAddress1' : null,
            'streetAddress2' : null,
            'state' : null,
            'city' : null,
            'countyCode' : null
        },
        'livingOutsideofStateTemporarilyIndicator' : null
    },
    'disabilityIndicator' : false,
    'heatingCoolingindicator' : false,
    'incarcerationStatus' : {
        'incarcerationManualVerificationIndicator' : false,
        'incarcerationStatusIndicator' : false,
        'useSelfAttestedIncarceration' : false,
        'incarcerationPendingDispositionIndicator' : null,
        'incarcerationAsAttestedIndicator' : false
    },
    'infantIndicator' : false,
    'childSupportExpense' : null,
    'expeditedIncome' : {
        'irsReportedAnnualIncome' : null,
        'expectedAnnualIncomeUnknownIndicator' : false,
        'irsIncomeManualVerificationIndicator' : false,
        'expectedAnnualIncome' : null
    },
    'migrantFarmWorker' : null,
    'fiveYearBar': false,
    'hasESI': false,
    'parentCaretaker': null,
    'fullTimeStudent': null,
    'status' : 'ADD_NEW',
    'medicaidChipDenial': false,
    'under26Indicator' : false,
    'externalId' : null,
    'requestRef' : null,
    'hardshipExempt' : null,
    'ecnNumber' : null,
    'ssiindicator' : false,
    'ipvindicator' : false,
    'pidverificationIndicator' : false,
    'pidindicator' : false
};

const OTHER_ADDRESS = {
    'address': {
        'postalCode': null,
        'county': null,
        'primaryAddressCountyFipsCode': null,
        'streetAddress1': null,
        'streetAddress2': null,
        'state': null,
        'city': null,
        'countyCode': null
    },
    'livingOutsideofStateTemporarilyAddress': {
        'postalCode': null,
        'county': null,
        'primaryAddressCountyFipsCode': null,
        'streetAddress1': null,
        'streetAddress2': null,
        'state': null,
        'city': null,
        'countyCode': null
    },
    'livingOutsideofStateTemporarilyIndicator': null
};

const SOCIAL_SECURITY_CARD = {
    middleNameOnSSNCard : null,
    deathManualVerificationIndicator : false,
    socialSecurityNumber : null,
    suffixOnSSNCard : null,
    individualMandateExceptionIndicator : false,
    ssnManualVerificationIndicator : false,
    deathIndicatorAsAttested : false,
    nameSameOnSSNCardIndicator : null,
    deathIndicator : false,
    firstNameOnSSNCard : null,
    socialSecurityCardHolderIndicator : null,
    useSelfAttestedDeathIndicator : false,
    lastNameOnSSNCard : null,
    reasonableExplanationForNoSSN : null,
    noSsnIssuedAttestation: null,
    appliedForSSN: null,
    notAppliedForSSNReason: NotAppliedForSSNReason.UNSPECIFIED,
};

const TRIBE_STATUS = {
    tribeName: null,
    tribeFullName: null,
    state: null,
    stateFullName: null,
    memberOfFederallyRecognizedTribeIndicator: null,
    americanIndianAlaskaNativeSelfIdentification: null
};

const SPECIAL_CIRCUMSTANCES = {
    pregnantIndicator: false,
    numberBabiesExpectedInPregnancy: null,
    currentlyPregnant: null,
    endDateOfPregnancy: null,
    dueDateOfPregnancy: null,
    startDateOfPregnancy: null
};

const FOSTER_CARE = {
    everInFosterCareIndicator: false,
    fosterCareState: null,
    gettingHealthCareThroughStateMedicaidIndicator: null,
    ageWhenLeftFosterCare: null
};

const MEDICAID_CHIP_DENIAL = {
    medicaidChipDenial: null,
    medicaidDeniedDate: null,
    medicaidDeniedDueToImmigration: null,
    changeInImmigrationSince5Year: null,
    changeInImmigrationSinceMedicaidDenial: null
};

const BHP_DENIAL = {
    bhpDenied: null,
    bhpDenialDate: null
};

const MEDICAID_TERMINATION_DETAILS = {
    householdIncomeOrSizeChanged: null,
    medicaidChipExpirationDate: null,
    medicaidTermination: null
};

const DISABILITY_INFO = {
    blindOrDisabled: false,
    longTerm: false,
    disabilityIndicator: false
};

const OTHER_IMMIGRATION_DOCUMENTS = {
    'cubanHaitianEntrantIndicator' : false,
    'americanSamoanIndicator' : false,
    'stayOfRemovalIndicator': false,
    'orreligibilityLetterIndicator' : false,
    'orrcertificationIndicator' : false,
    'withholdingOfRemovalIndicator': false,
    'domesticViolence': false,
    'indianOfUsOrCanada': false,
    'deportationWithheldInaIndicator': false,
    'refugeeIndicator': false,
    'specialIraqiAfghaniImmigrantIndicator': false,
    'victimSevereTraffickingIndicator': false,
    'conditionalEntrantIndicator': false,
    'lawfulPermanentResidentIndicator': false,
    'paroledAtLeastOneYearIndicator': false,
    'temporaryNonimmigrantIndicator': false,
    'deferredActionChildhoodArrivalsIndicator': false,
    'amerasianNoncitizenIndicator': false,
    'asyleeIndicator': false,
    'cofaMigrantIndicator': false,
    'otherIndicator': false,
    'noneOfThese': false
};

const PROGRAM_TYPES =  [
    {
        'name': 'Medicaid',
        'eligible': null
    },
    {
        'name': 'CHIP',
        'eligible': null
    },
    {
        'name': 'Medicare',
        'eligible': null
    },
    {
        'name': 'TRICARE',
        'eligible': null
    },
    {
        'name': 'Veterans Affairs (VA) Health Care Program',
        'eligible': null
    },
    {
        'name': 'Peace Corps',
        'eligible': null
    },
    {
        'name': 'Employer Insurance',
        'eligible': null
    },
    {
        'name': 'COBRA Coverage',
        'eligible': null
    },
    {
        'name': 'Retire Health Benefits',
        'eligible': null
    },
    {
        'name': 'Other Coverage',
        'eligible': null
    },
    {
        'name': 'None Of the Above',
        'eligible': null
    }];

const CURRENT_OTHER_INSURANCE = {
    'currentlyHasHealthInsuranceIndicator' : false,
    'currentOtherInsurance' : {
        'peaceCorpsIndicator' : false,
        'otherStateOrFederalProgramType' : null,
        'tricareEligibleIndicator' : false,
        'nonofTheAbove' : null,
        'otherStateOrFederalProgramName' : null,
        'medicareEligibleIndicator' : false,
        'otherStateOrFederalProgramIndicator' : false
    }
};

const OTHER_INSURANCE = {
    'endDate': null,
    'insuranceName': '',
    'policyNumber': '',
    'limitedBenefit': false
};

const MEDICARE_INSURANCE = {
    'enrolled': null,
    'startDate': null,
    'marketplaceCoverage': 'UNSPECIFIED'
};

const CURRENT_EMPLOYER_INSURANCE = {
    'currentLowestCostSelfOnlyPlanName': '',
    'willBeEnrolledInEmployerPlanIndicator': false,
    'memberEmployerPlanStartDate': null,
    'willBeEnrolledInEmployerPlanDate': null,
    'comingPlanMeetsMinimumStandardIndicator': false,
    'memberPlansToDropEmployerPlanIndicator': true,
    'employerWillOfferPlanIndicator': true,
    'expectedChangesToEmployerCoverageIndicator': true,
    'employerCoverageEndingDate': null,
    'memberPlansToEnrollInEmployerPlanIndicator': true,
    'employerPlanStartDate': null,
    'memberEmployerPlanEndingDate': null,
    'comingLowestCostSelfOnlyPlanName': '',
    'currentPlanMeetsMinimumStandardIndicator': false,
    'employerWillNotOfferCoverageIndicator': false,
    'isCurrentlyEnrolledInEmployerPlanIndicator': false,
    'insuranceName': null,
    'policyNumber': null
};

const TAX_HOUSEHOLD = {
    'primaryTaxFilerPersonId': 0,
    'reconciledAptc': true,
    'failureToReconcile': false
};

export const EMPTY_OBJECTS = {
    AUTHORIZED_REPRESENTATIVE,
    CITIZENSHIP_DOCUMENT,
    CITIZENSHIP_STATUS,
    CURRENT_EMPLOYER_INSURANCE,
    CURRENT_OTHER_INSURANCE,
    DISABILITY_INFO,
    EMPLOYER_DETAILS,
    FOSTER_CARE,
    HOUSEHOLD_COMPOSITION,
    HRA_DETAILS,
    MEDICARE_INSURANCE,
    PROGRAM_TYPES,
    BHP_DENIAL,
    MEDICAID_CHIP_DENIAL,
    MEDICAID_TERMINATION_DETAILS,
    MEDICAID_VERIFICATION,
    HOUSEHOLD_CONTACT,
    HOUSEHOLD_MEMBER,
    OTHER_ADDRESS,
    OTHER_IMMIGRATION_DOCUMENTS,
    OTHER_INSURANCE,
    SOCIAL_SECURITY_CARD,
    SPECIAL_CIRCUMSTANCES,
    TAX_HOUSEHOLD,
    TRIBE_STATUS
};
